<template>
  <v-autocomplete
    class="custom-autocomplete"
    v-model="model"
    :label="label"
    :items="itemsSorted"
    :item-value="itemValue"
    :item-text="itemText"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly || $store.getters.isLoadingActive"
    :multiple="isMultiple"
    :outlined="isOutlined"
    :filled="isFilled"
    :small-chips="isSmallChips"
    :item-disabled="(item) => item.disableHidden"
    :menu-props="{contentClass: 'custom-autocomplete-menu'}"
    @input="$emit('input', model)"
    hide-details
    return-object>
    <!-- Slots Passthru -->
    <template
      v-for="(index, name) in $scopedSlots"
      v-slot:[name]="data">
      <slot
        :name="name"
        v-bind="data">
      </slot>
    </template>
    <!-- / Slots Passthru -->
  </v-autocomplete>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'Autocomplete',
  props: [
    'items',
    'itemValue',
    'itemText',
    'label',
    'value',
    'placeholder',
    'disabled',
    'readonly',
    'multiple',
    'smallChips',
    'outlined',
    'filled',
    'includeAny',
  ],
  data() {
    return {
      model: undefined,
    };
  },
  computed: {
    itemsSorted() {
      let items = _.orderBy(this.items, this.itemText);
      const itemValue = this.itemValue || 'value';
      const itemText = this.itemText || 'text';

      if (this.includeAny === '') {
        items = [{
          [itemValue]: undefined,
          [itemText]: this.anyOption,
        }].concat(items);
      }

      if (!this.value) {
        return items;
      }

      const selectedValueIsHidden = _.filter(
        items,
        { [itemValue]: this.value[itemValue] },
      ).length === 0;

      if (selectedValueIsHidden && typeof this.value === 'object') {
        const hiddenOption = _.clone(this.value);
        hiddenOption[itemText] = `${hiddenOption[itemText]} (Hidden)`;
        hiddenOption.disableHidden = true;
        items.unshift(hiddenOption);
      }

      return items;
    },
    isMultiple() {
      return this.multiple === '' || this.multiple;
    },
    isSmallChips() {
      return this.smallChips === '' || this.smallChips;
    },
    isOutlined() {
      return this.outlined === '' || this.outlined;
    },
    isFilled() {
      return this.filled === '' || this.filled;
    },
  },
  watch: {
    value(value) {
      this.model = value;
    },
  },
  created() {
    this.model = this.value;
  },
};
</script>

<style lang="scss">
.custom-autocomplete-menu {
  .v-list-item--disabled {
    display: none;
  }
}
</style>
